import {z} from 'zod';

import i18n from '@dms/i18n';

export const VehicleGroupFormSchema = z.object({
  name: z.string().trim().min(1, i18n.t('general.validations.fieldIsRequired')),
  vehicleType: z.string().nullable().optional(),
  vehicleMake: z.string().nullable().optional(),
  vehicleModel_families: z.array(z.string().trim().nullable()).nullable().optional(),
  vehicleModels: z.array(z.string().trim().nullable()).nullable().optional(),
});

export type VehicleGroupFormValues = z.infer<typeof VehicleGroupFormSchema>;
